<template>
  <div>
    <nav-bar></nav-bar>
    <div class="container-fluid pt-3">
      <router-view/>
    </div>
  </div>
</template>
<script>
import NavBar from '@/admin/components/NavBar.vue';


export default {
  components: {
    NavBar,
  },
};
</script>
